// extracted by mini-css-extract-plugin
export var container = "FAQ-module--container--CXoGj";
export var heading = "FAQ-module--heading--JkDyd";
export var question = "FAQ-module--question--JdWIx";
export var answer = "FAQ-module--answer--h6VpX";